// Libs
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// State
import { appConfig } from '../model/context/app/app';

// Translations
import { de } from './translations/de';
import { en } from './translations/en';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .init({
        fallbackLng: appConfig.languages,
        supportedLngs: appConfig.languages,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: { 'en-GB': en, 'de-DE': de },
    })
    .then(() => {
        i18n.on('languageChanged', (language) => {
            document.documentElement.setAttribute('lang', language);
        });
    });
